<template>
    <div class="create">
        <el-dialog :title="_type == 'create' ? '添加' : '编辑'" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <div class="main" v-loading="formload">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="right" class="demo-ruleForm">
                    <el-form-item label="品牌名称：" prop="name">
                        <el-input v-model="ruleForm.name" clearable placeholder="请输入品牌名称"></el-input>
                        <span class="mytip">如有英文名称，用英文逗号隔开</span>
                    </el-form-item>
                    <div v-for="(item, index) in delTagList" :key="index">
                        <el-form-item :label="`${item.label}：`">
                            <el-input v-model="item.title" :placeholder="`请输入${item.type == 6 ? '' : item.label}${item.type != '6' ? '名称' : '内容'}`" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-upload
                                class="upload-demo"
                                ref="upload"
                                action="https://jsonplaceholder.typicode.com/posts/"
                                :limit="1"
                                :on-exceed="handleExceed"
                                :auto-upload="false"
                                :file-list="item.image"
                                :on-change="(file, fileList) => handleChange(file, fileList, item)"
                                :on-remove="(file, fileList) => handleRemove(file, fileList, item)"
                                :on-preview="(file) => handlePreview(file)"
                            >
                                <el-button slot="trigger" size="small" type="primary" :loading="btnload">上传文件</el-button>
                                <div slot="tip" class="el-upload__tip">支持JPG、PNG、PDF格式</div>
                            </el-upload>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="contentManage">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="添加内容" name="first">
                            <div class="tag-group" v-if="tagList.length > 0">
                                <el-tag type="info" @click="addTag(index, item)" v-for="(item, index) in tagList" :key="index">+ {{ item.label }}</el-tag>
                            </div>
                            <p v-else style="text-align: center; padding-top: 10px">暂无标签！</p>
                        </el-tab-pane>
                        <el-tab-pane label="管理内容" name="second">
                            <div class="tag-group" v-if="delTagList.length > 0">
                                <el-tag type="info" closable @close="closeTag(index, item)" v-for="(item, index) in delTagList" :key="index">{{ item.label }}</el-tag>
                            </div>
                            <p v-else style="text-align: center; padding-top: 10px">暂无标签！</p>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="medium">取 消</el-button>
                <el-button @click="submit('ruleForm')" type="primary" size="medium" :loading="load">确 认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="imgDialogVisible" width="500px">
            <img width="100%" :src="imgUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            imgDialogVisible: false,
            imgUrl: "",
            activeName: "first",
            dialogVisible: false,
            load: false,
            formload: false,
            ruleForm: {
                name: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入活动名称",
                        trigger: "blur",
                    },
                ],
            },
            tagList: [
                { label: "商标", type: "1", title: "", image: [], file: [] },
                { label: "专利", type: "2", title: "", image: [], file: [] },
                { label: "ISO证书", type: "3", title: "", image: [], file: [] },
                { label: "3C证书", type: "4", title: "", image: [], file: [] },
                { label: "软著", type: "5", title: "", image: [], file: [] },
                { label: "其他", type: "6", title: "", image: [], file: [] },
            ],
            delTagList: [],
            id: "",
            btnload: false,
        };
    },
    props: {
        _type: {
            type: String,
            default: "",
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            addBrand: "brand/addBrand",
            uploadFile: "commodity/uploadFile",
            getBrandDetail: "brand/getBrandDetail",
            updateBrand: "brand/updateBrand",
        }),
        getTable(id) {
            this.id = id;
            this.formload = true;
            let opt = {
                token: this.getToken,
                id: id,
            };
            this.getBrandDetail(opt).then(({ data }) => {
                this.formload = false;
                if (data.code == 1) {
                    this.ruleForm = data.data;
                    if (this.ruleForm.property_list.length > 0) {
                        this.ruleForm.property_list.forEach((item, index) => {
                            let ind, ite;
                            let f = this.tagList.some((v, i) => {
                                if (Number(item.type) == Number(v.type)) {
                                    ind = i;
                                    v.id = item.id;
                                    v.title = item.title;
                                    let obj = {
                                        url: item.image,
                                        name: item.image,
                                    };
                                    v.image = [];
                                    v.image.push(obj);
                                    ite = v;
                                }
                                return Number(item.type) === Number(v.type);
                            });
                            if (f) {
                                this.addTag(ind, ite);
                            }
                        });
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.load = true;
                    let flag = this.delTagList.some((item) => {
                        return item.title.trim() == "" || item.image.length == 0;
                    });
                    if (flag) {
                        this.load = false;
                        return this.$message.warning("名称或图片不能为空！");
                    }
                    let arr = [];
                    this.delTagList.forEach((item) => {
                        let obj = {
                            title: item.title,
                            type: item.type,
                            image: item.image[0].url,
                        };
                        if (item.id) {
                            obj.id = item.id;
                        }
                        arr.push(obj);
                    });
                    let opt = {
                        token: this.getToken, //token
                        name: this.ruleForm.name, //品牌名称
                        property_list: arr,
                    };
                    let url;
                    if (this._type == "create") {
                        url = this.addBrand;
                    } else {
                        url = this.updateBrand;
                        opt.id = this.id;
                    }
                    // console.log(this._type);
                    url(opt).then(({ data }) => {
                        this.load = false;
                        if (data.code == 1) {
                            this.$message.success(`${this._type == "create" ? "添加" : "编辑"}成功！`);
                            this.$emit("init");
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleExceed(files, fileList) {
            this.$message.warning("只能上传1个文件，请先删除当前文件，再重新上传");
            return false;
        },
        handleChange(file, fileList, item) {
            // console.log(file, fileList);
            this.btnload = true;
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            item.file = fileList;
            item.image = [];
            this.uploadFile(formdata).then((res) => {
                this.btnload = false;
                this.load = false;
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: "上传成功！",
                    });
                    item.image.push({ name: file.name, url: res.data.formdata_details[0].urls });
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        /*文件移除*/
        handleRemove(file, fileList, item) {
            item.file.map((v, i) => {
                if (v.name == file.name) {
                    item.file.splice(i, 1);
                }
            });
        },
        // 数组按照某个属性排序
        compare(propertyName) {
            return function (object1, object2) {
                var value1 = object1[propertyName];
                var value2 = object2[propertyName];
                if (value2 > value1) {
                    return -1;
                } else if (value2 < value1) {
                    return 1;
                } else {
                    return 0;
                }
            };
        },
        addTag(i, v) {
            this.tagList.splice(i, 1);
            this.delTagList.push(v);
            this.delTagList.sort(this.compare("type"));
        },
        closeTag(i, v) {
            if (v.title.trim() != "") {
                return this.$message.warning(`${v.label}有内容，无法关闭！`);
            }
            this.delTagList.splice(i, 1);
            v.title = "";
            v.image = [];
            this.tagList.push(v);
            this.tagList.sort(this.compare("type"));
        },
        handleClose() {
            this.load = false;
            this.formload = false;
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm.name = "";
            this.tagList = [
                { label: "商标", type: "1", title: "", image: [], file: [] },
                { label: "专利", type: "2", title: "", image: [], file: [] },
                { label: "ISO证书", type: "3", title: "", image: [], file: [] },
                { label: "3C证书", type: "4", title: "", image: [], file: [] },
                { label: "软著", type: "5", title: "", image: [], file: [] },
                { label: "其他", type: "6", title: "", image: [], file: [] },
            ];
            this.delTagList = [];
        },
        isImage(val) {
            let ext = val.split(".").pop().toLowerCase();
            return ext == "jpg" || ext == "png" || ext == "jpeg";
        },
        handlePreview(file) {
            this.imgUrl = file.url;
            if (this.isImage(this.imgUrl)) {
                this.imgDialogVisible = true;
            } else {
                window.open(this.imgUrl);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    .demo-ruleForm {
        max-height: 420px;
        overflow-y: auto;

        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        h3 {
            margin-bottom: 20px;
            padding: 10px 0;
        }
        ::v-deep .el-form-item {
            width: 500px;
        }
    }
    .tag-group {
        padding-top: 10px;
        .el-tag {
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            height: 34px !important;
            line-height: 34px !important;
            font-size: 14px;
        }
    }
    .el-date-editor .el-range-separator {
        width: auto !important;
    }
    .upload-demo {
        position: relative;
        .down {
            position: absolute;
            right: 180px;
            top: 0;
            .el-link {
                font-size: 12px;
                line-height: 20px;
            }
        }
    }
    .mytip {
        font-size: 12px;
        color: #999;
    }
}
</style>